import { localeKeys } from 'i18n';

const errorKeys = ['error-unexpected', 'error-bad-request'] as const;
errorKeys.forEach(k => console.assert(localeKeys.includes(k)));
export type ErrorKey = typeof errorKeys[number];
